export const workflow: Record<string, string> = {
  Closed: 'Lezárva',
  ERROR: 'Hiba',
};
